import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'
import { getOpportunityById } from 'api'
import { format as formatDate } from 'date-fns'

const BreadcrumbNav = [
  {
    label: 'Opportunities',
    path: '/opportunities'
  },
  {
    label: 'View',
    isCurrentPage: true
  }
]

export const ViewOpportunity = () => {
  const { opportunityId } = useParams()
  const { createToast } = useAppContext()
  const [opportunity, setOpportunity] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const load = async () => {
    setIsLoading(true)
    try {
      const response = await getOpportunityById(opportunityId)
      setOpportunity(response)
      setIsLoading(false)
    } catch (e) {
      createToast('Failed to load opportunity')
      setIsLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [opportunityId])

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">View Opportunity</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            {(isLoading || !opportunity) ? (
              <Text>Loading ...</Text>
            ) : (
              <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Opportunities Owner</Text>
                    <Text flex={1}>{opportunity.salesUserName}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Amount</Text>
                    <Text flex={1}>{opportunity.amount}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Opportunities Name</Text>
                    <Text flex={1}>{opportunity.name}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Closing Date</Text>
                    <Text flex={1}>{opportunity.closingDate ? formatDate(new Date(new Date(opportunity.closingDate).getTime() + new Date(opportunity.closingDate).getTimezoneOffset() * 60000), 'MM/dd/yyyy') : 'N/A'}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Account Name</Text>
                    <Text flex={1}>{opportunity.customerCompany}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Stage</Text>
                    <Text flex={1}>{opportunity.stage}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Contact Name</Text>
                    <Text flex={1}>{opportunity.customerName}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Sign Type</Text>
                    <Text flex={1}>{opportunity.signType ? JSON.parse(opportunity.signType).join(', ') : ''}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Email</Text>
                    <Text flex={1}>{opportunity.email}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Probability (%)</Text>
                    <Text flex={1}>{opportunity.probability}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Phone</Text>
                    <Text flex={1}>{opportunity.phone}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Installation State (KY)</Text>
                    <Text flex={1}>{opportunity.state}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Installation Address</Text>
                    <Text flex={1}>{opportunity.address}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Installation Zip</Text>
                    <Text flex={1}>{opportunity.zip}</Text>
                  </Flex>
                </GridItem>
                <GridItem>
                  <Flex gap={4}>
                    <Text flex={1} color="gray.500">Campaign ID</Text>
                    <Text flex={1}>{opportunity.campaignID ? JSON.parse(opportunity.campaignID).join(', ') : ''}</Text>
                  </Flex>
                </GridItem>
              </Grid>
            )}
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
